<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>奖励进度获取配置</span>
    </div>
    <el-form :inline="true">
      <el-form-item label="分组" style="margin-top: 5px" prop="steal_break">
        <el-select v-model.number="reward_conf.groupId" placeholder="请选择" @change="groupChange">
          <el-option
            v-for="item in groupType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="numShow" label="收集物数量" style="margin-top: 5px" prop="steal_break">
        <el-input v-model.number="reward_conf.num" style="width: 200px" />
      </el-form-item>
    </el-form>
    <el-form :inline="true">
      <el-row v-for="(coll, i) in reward_conf.collectBak" :key="i">
        <el-form-item label="类型" style="margin-top: 5px;" prop="type">
          <el-select v-model="coll.type" placeholder="请选择类型" @change="(v)=>{ return selectTypeChange(v)}">
            <el-option v-for="(item, index) in selectType" :key="index" :disabled="item.disabled" :label="item.title" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="倍数" style="margin-top: 5px" prop="bet">
          <el-input v-model.number="coll.bet" style="width: 200px" />
        </el-form-item>
        <el-form-item style="margin-top: 5px">
          <el-button type="danger" @click="delCollect(i)">删除</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <el-button style="margin-top: 5px" type="primary" @click="addCollect">+</el-button>
    <el-button :disabled="isOnline" type="primary" @click="saveActivityRewardConf()">保存</el-button>
  </el-card>

</template>

<script>
import {
  getCollectTypesList,
  getStealAttackTYpesList,
  getActivtyList,
  updateActivtyRewardConfData
} from '@/api/config/activity-cfg'
import { getCacheConfig } from '@/utils'

export default {
  name: 'ActRewardProcess',
  props: {
    isOnline: {
      type: Boolean,
      default: false
    },
    aid: {
      type: String,
      default: '0'
    },
    typ: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      actType: '',
      tempStealType: [],
      reward_conf: { num: 0, groupId: 0, collect: {}, collectBak: [] },
      randTypes: ['rank', 'rank2'],
      collectType: ['super_collect', 'super_collect2', 'super_collect3', 'rank', 'rank2'],
      selectType: [],
      numShow: false,
      exactArr: [6, 7, 8, 9, 10, 11, 12],
      groupType: [
        { label: '常规收集', value: 1, disabled: false },
        { label: '特殊收集', value: 2, disabled: false },
        { label: '特殊收集偷', value: 3, disabled: false },
        { label: '特殊收集打', value: 4, disabled: false },
        { label: '偷', value: 5, disabled: false },
        { label: '打', value: 6, disabled: false },
        { label: '特殊收集+偷+打', value: 7, disabled: false },
        { label: '收集偷', value: 8, disabled: false },
        { label: '收集打', value: 9, disabled: false },
        { label: '偷打', value: 10, disabled: false } // 竞标赛
      ]
    }
  },
  created() {
    this.actType = this.$route.query.type
    this.getActCollectTypes()
    // this.getActStealAttackTypes()
    this.getActivity()
  },
  methods: {
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          const reward_conf = res.data.list[0].reward_conf
          if (reward_conf) {
            reward_conf.collectBak = []
            for (const i in reward_conf.collect) {
              const typ = parseInt(i)
              if (!this.exactArr.includes(typ)) {
                reward_conf.collectBak.push({ type: typ, bet: reward_conf.collect[i], disabled: false })
              }
            }
            this.reward_conf = reward_conf
            this.groupChange(reward_conf.groupId)
            this.changeGroupType()
            this.listenChangeType()
          }
        }
      })
    },
    saveActivityRewardConf() {
      // const obj = {}
      // for (const i in this.reward_conf.collectBak) {
      //   const val = this.reward_conf.collectBak[i]
      //   obj[val.type] = val.bet
      // }

      if (this.collectType.includes(this.actType)) {
        const groupId = this.reward_conf.groupId
        const collect = this.reward_conf.collectBak
        const num = this.reward_conf.num
        const newCollect = { num: num, groupId: groupId, collect: {}}
        let selectNumBet = 0
        for (const i in collect) {
          const _collect = collect[i]
          newCollect.collect[_collect.type] = _collect.bet
          if (_collect.type === 5) {
            this.numShow = true
            selectNumBet = _collect.bet
          }
        }
        // 加入金币
        if (this.numShow) {
          for (let i = 6; i <= 12; i++) {
            newCollect.collect[i] = selectNumBet
          }
        }
        this.reward_conf = newCollect
      }
      const data = JSON.stringify(this.reward_conf)
      updateActivtyRewardConfData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    selectTypeChange(v, $event) {
      this.selectType.forEach((item, index) => {
        if (item.id === v) {
          this.selectType[index].disabled = true
        }
      })
      this.listenChangeType()
    },
    listenChangeType() {
      const collect = this.reward_conf.collectBak
      this.numShow = false
      if (this.selectType.length <= 0) {
        for (const i in this.reward_conf.collectBak) {
          const val = this.reward_conf.collectBak[i]
          if (this.reward_conf.groupId !== 10 && val.type === 5) {
            this.numShow = true
            break
          }
        }
      } else {
        for (const index in this.selectType) {
          this.selectType[index].disabled = false
          for (const i in collect) {
            if (collect[i].type === this.selectType[index].id && !this.selectType[index].disabled) {
              this.selectType[index].disabled = true
              if (this.reward_conf.groupId !== 10 && this.selectType[index].id === 5 && !this.numShow) {
                this.numShow = true
              }
              break
            }
          }
        }
      }
    },
    delCollect(i) {
      this.reward_conf.collectBak = this.reward_conf.collectBak.filter((item, index) => {
        return i !== index
      })
      this.listenChangeType()
    },
    addCollect() {
      this.listenChangeType()
      let selectVal = ''
      const selectType = this.selectType

      for (const i in selectType) {
        if (!selectType[i].disabled) {
          selectVal = selectType[i].id
          this.selectType[i].disabled = true
          break
        }
      }

      if (!selectVal) {
        this.msgError('没有可选的类型')
        return
      }

      this.reward_conf.collectBak.push({
        type: selectVal,
        bet: 0
      })
      this.listenChangeType()
    },
    groupChange(v) {
      if (this.randTypes.includes(this.actType) && v === 10) {
        this.getActStealAttackTypes()
      } else {
        this.getActCollectTypes()
      }
    },
    changeGroupType() {
      this.groupType.forEach((item, index) => {
        if (item.value === 10 && !this.randTypes.includes(this.actType)) {
          this.groupType[index].disabled = true
        }
      })
    },
    getActStealAttackTypes() {
      this.selectType = []
      this.tempStealType = []
      getCacheConfig(getStealAttackTYpesList, 'getStealAttackTYpesList').then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.tempStealType.push(parseInt(i))
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i), disabled: false })
          }

          // 清理
          const newCollect = []
          for (const i in this.reward_conf.collectBak) {
            const val = this.reward_conf.collectBak[i]
            if (this.tempStealType.includes(val.type)) {
              newCollect.push(val)
            }
          }

          this.reward_conf.collectBak = newCollect
          this.listenChangeType()
        }
      })
    },
    getActCollectTypes() {
      this.selectType = []
      getCacheConfig(getCollectTypesList, 'getCollectTypesList', {}).then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.selectType.push({ 'title': res.data[i], 'id': parseInt(i), disabled: false })
          }
        }
      })

      this.listenChangeType()
    }
  }
}
</script>

<style scoped>

</style>
